import { render } from "./BaseContainerRetailer.vue?vue&type=template&id=5f946182&ts=true"
import script from "./BaseContainerRetailer.vue?vue&type=script&lang=ts"
export * from "./BaseContainerRetailer.vue?vue&type=script&lang=ts"

import "./BaseContainerRetailer.vue?vue&type=style&index=0&id=5f946182&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__